import { render, staticRenderFns } from "./comment-form.vue?vue&type=template&id=40234e3d&scoped=true&"
import script from "./comment-form.vue?vue&type=script&lang=js&"
export * from "./comment-form.vue?vue&type=script&lang=js&"
import style0 from "./comment-form.vue?vue&type=style&index=0&id=40234e3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40234e3d",
  null
  
)

export default component.exports